import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { Alert, Container } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom';
import SmoothCollapse from 'react-smooth-collapse'
import TagManager from 'react-gtm-module'
import ChangeAddress from '../../components/changeAddress/ChangeAddress'
import { getErrorWithFullMessage } from 'exports'
import { checkIsMobile, getCustomerInfoCookieName } from 'utils/helpers'
import appConfig from '../../app.config'
import { appRoutes } from '../../constants/routes/Routes'
import useStateWithSessionStorage from '../../hooks/useStateWithSessionStorage'
import { ICustomer } from '../../interfaces/i-api-loan'
import customerDataApiService from '../../services/customerDataApiService'
import { CookieType } from '../../constants/cookieTypes'
import { animated } from 'react-spring'
import UserAddressInfo from '../userAddressInfo/UserAddressInfo'
import { TranslationFile } from 'i18n'

function UserPage() {
	const { t } = useTranslation([
		TranslationFile.Translation,
		TranslationFile.Languages,
	])

	const navigate = useNavigate();
	const [isShown, setIsShown] = useState(false)
	const [marketingExpanded, setMarketingExpanded] = useState(false)
	const [showMessage, setShowMessage] = useState(false)

	const [value] = useStateWithSessionStorage(getCustomerInfoCookieName())
	const [personal, setPersonal] = useState<ICustomer>(
		JSON.parse(value.toString()),
	)

	const [error, setError] = useState<Error>()

	const handleClose = (customerData: ICustomer) => {
		setIsShown(false)
		setPersonal(customerData)
	}

	const tagManagerArgs = {
		dataLayer: {
			userId: '001',
			userProject: 'project',
			page: '/user',
		}
	}

	React.useEffect(() => {
		TagManager.dataLayer(tagManagerArgs)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	async function onClick() {
		let tempPersonal = Object.assign({
			...personal,
			customerFlags: {
				...personal.customerFlags,
				noAdvertisement: !personal.customerFlags.noAdvertisement,
			},
		})

		try {
			await customerDataApiService
				.updateCustomerDetails(tempPersonal, t)
				.then(() => setPersonal(tempPersonal))
				.then(() => setShowMessage(true))
		} catch (error: any) {
			setError(getErrorWithFullMessage(error))
		}
	}

	const isMobile = checkIsMobile()

	return (
		<div id="user-page">
			<Container className="px-0 bg">
				<Container
					id="container-user-page"
					className={isMobile ? '' : 'margin-bottom'}>
					<div
						style={{
							width: !isMobile && isShown ? '100%' : '',
							margin: 'auto',
						}}>
						{!isShown && (
							<animated.div id="user-page-animated">
								<div>
									{error ? (
										<Alert
											variant="danger"
											dismissible
											onClose={() => setError(undefined)}>
											{error.message}
										</Alert>
									) : null}
									<h1 className="mb-3">
										{personal.personalInfo?.firstName}
										{appConfig.country === 'fi'
											? ` ${personal.personalInfo.lastName}`
											: ''}
									</h1>
									<p>{t('ContactInfo')}</p>
									<br />
									<p>
										<b>{t('Email')}: </b>
										{personal.contacts?.email}
									</p>
									<p>
										<b>{t('Phone')}: </b>
										{personal.contacts?.cellPhone}
										<FontAwesomeIcon
											onClick={() => setIsShown(!isShown)}
											className="d-inline float-right pointer"
											icon="edit"
										/>
									</p>
									<br />
									<UserAddressInfo
										personalInfo={personal.personalInfo}
										address={personal.address}
										title={t('RegisteredAddressTitle')}
										isEstonianMarket={appConfig.country === 'ee'}
									/>
									<br />
									{personal.invoiceAddress &&
										<br />
									}
									{personal.invoiceAddress && 
										<UserAddressInfo
											personalInfo={personal.personalInfo}
											address={personal.invoiceAddress}
											title={t('InvoiceAddressTitle')}
											isEstonianMarket={appConfig.country === 'ee'}
										/>
									}
								</div>
								{!sessionStorage.getItem(
									CookieType.DepositCustomer,
								) &&
									!['lt', 'no'].includes(
										appConfig.country,
									) && (
										<div>
											<p
												onClick={() =>
													setMarketingExpanded(
														!marketingExpanded,
													)
												}
												className="mt-5 pointer">
												{t('MarketingHeading')}{' '}
												<FontAwesomeIcon
													icon={
														marketingExpanded
															? 'chevron-up'
															: 'chevron-down'
													}
												/>
											</p>

											{personal.customerFlags !==
												null && (
												<SmoothCollapse
													expanded={marketingExpanded}
													children={
														<div className="text-user-page">
															{personal
																.customerFlags
																.noAdvertisement ? (
																<p className="d-inline">
																	{t(
																		'SubscribeText',
																	)}
																</p>
															) : (
																<p className="d-inline">
																	{t(
																		'UnsubscribeText',
																	)}
																</p>
															)}
															<br />

															<button
																className={
																	'component-button btn-subscribe btn'
																}
																onClick={
																	onClick
																}>
																{personal
																	.customerFlags
																	.noAdvertisement
																	? t(
																			'SubscribeBtn',
																	  )
																	: t(
																			'UnsubscribeBtn',
																	  )}
															</button>
															<br />
															{showMessage &&
																(personal
																	.customerFlags
																	.noAdvertisement ? (
																	<p className="d-inline response-text">
																		{t(
																			'ResponseTextUnsubscribe',
																		)}
																	</p>
																) : (
																	<p className="d-inline response-text">
																		{t(
																			'ResponseTextSubscribe',
																		)}
																	</p>
																))}
														</div>
													}
													allowOverflowWhenOpen={true}
												/>
											)}
										</div>
									)}

								<div>
									<button
                                            type="button"
                                            className="component-button btn-bold mt-5 mb-5 btn"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                setTimeout(() => {
                                                    navigate(appRoutes.logout)
                                                }, 400)
                                            }}>
                                            {t('SignOut')}
                                            <FontAwesomeIcon
                                                className="ml-2"
                                                icon="sign-out-alt"
                                            />
                                    </button>
								</div>
							</animated.div>
						)}

						{isShown && (
							<ChangeAddress
								hide={() => setIsShown(!isShown)}
								handleClose={handleClose}
								user={personal}
							/>
						)}
					</div>
				</Container>
			</Container>
		</div>
	)
}

export default UserPage